import { useState } from "react";
import { toast } from "sonner";

const OPTS = [
  { key: "napowietrzny", label: "Napowietrzny (na słupach)" },
  { key: "kanalizacja", label: "W kanalizacji" },
  { key: "kanalizacja OPL", label: "W kanalizacji OPL" },
  { key: "kanalizacja własna", label: "W kanalizacji własnej" },
  { key: "mikrokanalizacja", label: "W mikrokanalizacji" },
  { key: "doziemny", label: "Doziemny (w ziemi)" },
];
const DEF = { napowietrzny: "#3B82F6", kanalizacja: "#F59E0B", "kanalizacja OPL": "#F97316", "kanalizacja własna": "#EAB308", mikrokanalizacja: "#22C55E", doziemny: "#8B5CF6" };

export function CableColorSettings({ settings, save }) {
  const [colors, setColors] = useState({ ...DEF, ...(settings.cable_colors || {}) });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setColors((c) => ({ ...c, [k]: v }));
  const submit = async () => {
    setBusy(true);
    try { await save({ cable_colors: colors }); toast.success("Zapisano kolory kabli"); }
    catch { toast.error("Błąd zapisu"); }
    finally { setBusy(false); }
  };
  return (
    <div className="space-y-3">
      <p className="text-xs text-slate-400">Kolor linii kabla na mapie zależy od pola „Umieszczenie" w karcie kabla. Ustaw kolor dla każdego rodzaju prowadzenia kabla.</p>
      {OPTS.map((o) => (
        <div key={o.key} className="flex items-center gap-3" data-testid={`cablecolor-row-${o.key.replace(/\s/g, "-")}`}>
          <input type="color" value={colors[o.key] || "#3B82F6"} onChange={(e) => set(o.key, e.target.value)}
            data-testid={`cablecolor-${o.key.replace(/\s/g, "-")}`} className="w-10 h-8 rounded bg-transparent border border-slate-600 cursor-pointer" />
          <span className="w-14 h-2 rounded-full" style={{ background: colors[o.key] }} />
          <span className="text-sm flex-1">{o.label}</span>
          <span className="text-xs text-slate-500 uppercase">{colors[o.key]}</span>
        </div>
      ))}
      <button onClick={submit} disabled={busy} data-testid="cablecolor-save"
        className="w-full bg-blue-600 hover:bg-blue-700 rounded px-3 py-2 text-sm font-medium disabled:opacity-50">
        {busy ? "Zapisywanie…" : "Zapisz kolory kabli"}
      </button>
    </div>
  );
}
